'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = require('semantic-ui-react');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InsightReport = function (_React$Component) {
  (0, _inherits3.default)(InsightReport, _React$Component);

  function InsightReport() {
    (0, _classCallCheck3.default)(this, InsightReport);
    return (0, _possibleConstructorReturn3.default)(this, (InsightReport.__proto__ || (0, _getPrototypeOf2.default)(InsightReport)).apply(this, arguments));
  }

  (0, _createClass3.default)(InsightReport, [{
    key: 'render',
    value: function render() {
      var data = this.props.data;

      var posts = _lodash2.default.filter(_lodash2.default.get(data, 'data.posts'), function (post) {
        return _lodash2.default.get(post, 'trackedAsset.platform', '') === 'FACEBOOK';
      });
      var cf = function cf(num) {
        return (0, _numeral2.default)(num).format('0,0');
      };
      var sf = function sf(num) {
        return (0, _numeral2.default)(num).format('0.0');
      };

      var TYPE_ICONS = {
        VIDEO: 'youtube play',
        IMAGE: 'camera',
        TEXT: 'content',
        STORY: 'dollar'
      };

      var PLATFORM_COLORS = {
        INSTAGRAM: '#fb3958',
        YOUTUBE: '#FF0000',
        FACEBOOK: '#3b5998',
        TWITTER: '#00aced'
      };

      var getTotalOfKeys = function getTotalOfKeys(insights, metric) {
        var values = insights[metric];
        var total = _lodash2.default.reduce(values, function (result, value) {
          return result + value;
        });
        return total;
      };

      var getTopValue = function getTopValue(insights, metric) {
        if (!insights) return null;
        var values = insights[metric];
        var valuesArray = _lodash2.default.map(values, function (value, key) {
          return { key: key, value: value };
        });
        var orderedValues = _lodash2.default.orderBy(valuesArray, 'value', 'desc');

        var topValue = orderedValues[0] || { key: '-', value: 0 };
        return topValue;
      };

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _semanticUiReact.Table,
          { celled: true, size: 'small', compact: true, textAlign: 'center', unstackable: true, singleLine: true },
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                'platform'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                'text'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                'channel'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                'insights'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                _react2.default.createElement(_semanticUiReact.Popup, { content: 'Impressions', trigger: _react2.default.createElement(
                    'span',
                    null,
                    'imps'
                  ) })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                'reach'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                'views'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                'likes'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'facebook', color: 'blue' }),
                'reactions'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                'time watched',
                _react2.default.createElement('br', null),
                '(mins)'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                'top location',
                _react2.default.createElement('br', null),
                '(mins watched)'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                'top demographic',
                _react2.default.createElement('br', null),
                '(mins watched)'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                'avg. watch time',
                _react2.default.createElement('br', null),
                '(secs)'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                'insights',
                _react2.default.createElement('br', null),
                'collected'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            _lodash2.default.map(_lodash2.default.orderBy(posts, ['trackedAsset.platform', 'influencerName']), function (post, idx) {
              var ta = post.trackedAsset;
              var supportingData = ta.supportingData;
              var latestSupportingData = void 0;

              if (supportingData && supportingData.length) {
                var filtered = _lodash2.default.filter(supportingData, 'createdDate'); // remove the GraphQL null at [0]
                var ordered = _lodash2.default.reverse(_lodash2.default.sortBy(filtered, function (o) {
                  return o.createdDate;
                }));
                latestSupportingData = ordered[0];
              }

              var insights = post.latestStatistic.insights;
              var totalVideoViewTimeByRegionId = getTopValue(insights, 'totalVideoViewTimeByRegionId');
              var totalVideoViewTimeByAgeBucketAndGender = getTopValue(insights, 'totalVideoViewTimeByAgeBucketAndGender');

              var platform = _lodash2.default.toLower(ta.platform);
              var assetTypeIcon = TYPE_ICONS[ta.assetType];
              var fb = platform === 'facebook';
              var ig = platform === 'instagram';
              var shortText = _lodash2.default.truncate(post.text, { length: 60, separator: ' ' });
              var platformColor = PLATFORM_COLORS[ta.platform];

              return _react2.default.createElement(
                _semanticUiReact.Table.Row,
                { key: idx },
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { style: { color: platformColor, fontSize: '120%' } },
                  _react2.default.createElement(_semanticUiReact.Icon, { name: platform }),
                  _react2.default.createElement(_semanticUiReact.Icon, { name: assetTypeIcon })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { textAlign: 'left' },
                  _react2.default.createElement(
                    'a',
                    { target: '_blank', rel: 'noreferrer noopener', href: ta.assetURL },
                    _lodash2.default.truncate(shortText)
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  _react2.default.createElement(
                    'b',
                    null,
                    ig ? post.instagramHandle : post.influencerName
                  ),
                  _react2.default.createElement('br', null),
                  fb && post.facebookPageDescription
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  insights ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'check', color: 'green' }) : _react2.default.createElement(_semanticUiReact.Icon, { name: 'x', color: 'red' })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  fb && insights && _react2.default.createElement(
                    'span',
                    null,
                    cf(insights.totalVideoImpressions)
                  ),
                  latestSupportingData && _react2.default.createElement(
                    'span',
                    null,
                    cf(latestSupportingData.impressions)
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  fb && insights && _react2.default.createElement(
                    'span',
                    null,
                    cf(insights.totalVideoImpressionsUnique)
                  ),
                  latestSupportingData && _react2.default.createElement(
                    'span',
                    null,
                    cf(latestSupportingData.reach)
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  fb && insights && _react2.default.createElement(
                    'div',
                    null,
                    cf(insights.totalVideoViews)
                  ),
                  (fb || ig) && !insights && _react2.default.createElement(
                    'div',
                    null,
                    cf(post.latestStatistic.viewCount)
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  !insights && _react2.default.createElement(
                    'div',
                    null,
                    cf(post.latestStatistic.likeCount)
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  fb && insights && _react2.default.createElement(
                    'div',
                    null,
                    cf(getTotalOfKeys(insights, 'totalVideoReactionsByTypeTotal'))
                  ),
                  fb && !insights && _react2.default.createElement(
                    'div',
                    null,
                    cf(post.latestStatistic.reactionCount)
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  fb && insights && _react2.default.createElement(
                    'div',
                    null,
                    cf(getTotalOfKeys(insights, 'totalVideoViewTimeByDistributionType') / 60000)
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  fb && insights && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'b',
                      null,
                      getTopValue(insights, 'totalVideoViewTimeByRegionId').key
                    ),
                    _react2.default.createElement('br', null),
                    cf(totalVideoViewTimeByRegionId.value)
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  fb && insights && _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(
                      'b',
                      null,
                      totalVideoViewTimeByAgeBucketAndGender.key
                    ),
                    _react2.default.createElement('br', null),
                    cf(totalVideoViewTimeByAgeBucketAndGender.value / 60000)
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  fb && insights && _react2.default.createElement(
                    'span',
                    null,
                    sf(insights.totalVideoAvgTimeWatched / 1000)
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  fb && insights && _react2.default.createElement(
                    'span',
                    null,
                    (0, _moment2.default)(post.latestStatistic.createdDate).format('DD/MM/YYYY')
                  )
                )
              );
            })
          )
        )
      );
    }
  }]);
  return InsightReport;
}(_react2.default.Component);

InsightReport.propTypes = {
  data: _propTypes2.default.object.isRequired
};

exports.default = InsightReport;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dyzio-shared-components/lib/reports/insights-report/index.js
// module id = 2159
// module chunks = 1